module.exports = __webpack_public_path__ + "static/media/Group 497.b875a119.svg";